import { Link } from 'react-router';

import { Mascot } from '../mascot';

import styles from './style.module.css';

// psy's brand: the mascot with the lowercase name beside it, which replaced
// the wordmark on 2026-10-16. It is also the only way home, the patient's
// Today or the clinician's Dashboard: neither has a link or menu entry of its
// own (C28, C33). Both live at the root, and so do the landing page and the
// sign-in screen's way back, so the link needs nobody to be signed in.
//
// The name shows on a desktop. On a phone it shows only where nameOnPhone
// asks for it, the sign-in screen and the landing page; elsewhere the phone
// bar uses that space for the section's name. Hidden or not, the name is the
// link's text, so the link is called "psy" on every size.
export function Brand({ size, nameOnPhone }) {
  let name = styles.name;

  if (nameOnPhone !== true) {
    name = `${ styles.name } ${ styles.desktopName }`;
  }

  return (
    <Link className={ styles.brand } to='/' style={ { '--size': `${ size }px` } }>
      <Mascot size={ size }/>

      <span className={ name }>psy</span>
    </Link>
  );
}
